import { render, staticRenderFns } from "./CheckoutDesc.vue?vue&type=template&id=a1bb8ab2&scoped=true&"
import script from "./CheckoutDesc.vue?vue&type=script&lang=js&"
export * from "./CheckoutDesc.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutDesc.vue?vue&type=style&index=0&id=a1bb8ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bb8ab2",
  null
  
)

export default component.exports